import { clientFields, clientOperations } from './ClientDescription';
import { siteFields, siteOperations } from './SiteDescription';
import { ticketFields, ticketOperations } from './TicketDescription';
import { userFields, userOperations } from './UserDescription';

export {
	clientFields,
	clientOperations,
	siteFields,
	siteOperations,
	ticketFields,
	ticketOperations,
	userFields,
	userOperations,
};
